import { render, staticRenderFns } from "./InquiryBalance.vue?vue&type=template&id=2ff91783&scoped=true"
import script from "./InquiryBalance.vue?vue&type=script&lang=js"
export * from "./InquiryBalance.vue?vue&type=script&lang=js"
import style0 from "./InquiryBalance.vue?vue&type=style&index=0&id=2ff91783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff91783",
  null
  
)

export default component.exports